// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__MBMn3","search-area":"styles_search-area__a3Lm5","noScroll":"styles_noScroll__IkhUH","bg-navbar":"styles_bg-navbar__e0fhk"};